export default __webpack_public_path__ + "images/bignumber.b24009cac8342cf4eb352369e0d149c2.svg";